<script>
import { mapState } from 'vuex';

import Course from '@/models/Course.js';

export default {
    name: 'CoursePointsUpdatedChecker',

    computed: {
        ...mapState('Auth', { authUser: state => state.user }),

        echoReady() {
            return !!this.$store.state.Online.$echo;
        },
    },

    watch: {
        echoReady(ready) {
            if (ready) {
                this.$echo.channel('course-points-updated').listen('CoursePointsUpdated', async courseData => {
                    if (!Course.find(courseData.id)) {
                        // Assuming that the course is not in the store because the user doesn't have access to it.
                        return;
                    }

                    courseData.points_possible = courseData.points_possible || courseData.points_possible_cache;
                    courseData.total_points_possible =
                        courseData.total_points_possible || courseData.total_points_possible_cache;
                    courseData.extra_credit_points =
                        courseData.extra_credit_points || courseData.extra_credit_points_cache;
                    courseData.total_remediation_points =
                        courseData.total_remediation_points || courseData.total_remediation_points_cache;

                    await Course.update({
                        where: courseData.id,
                        data: courseData,
                    });
                });
            }
        },
    },

    render: () => null,
};
</script>
